export interface JourneyOverview {
  _id: string;
  name: string;
  cpf: string;
  plate: string;
  journey_time: number;
  extra_hours?: number;
  status: JOURNEY_OVERVIEW_STATUS;  
  worked_hours: {
    time?: number;
    infractions?: number;
    events?: number;
    status: JOURNEY_OVERVIEW_STATUS;  
  };
  meal: {
    time?: number;
    infractions?: number;
    events?: number;
    status: JOURNEY_OVERVIEW_STATUS;  
  };
  waiting: {
    time?: number;
    infractions?: number;
    events?: number;
    status: JOURNEY_OVERVIEW_STATUS; 
  };
  free_time: {
    time?: number;
    infractions?: number;
    events?: number;
    status: JOURNEY_OVERVIEW_STATUS; 
  };
  journey_end: {
    time?: number;
    infractions?: number;
    events?: number;
    status: JOURNEY_OVERVIEW_STATUS; 
  };
}

export enum JOURNEY_OVERVIEW_STATUS {
  OK = 'Consta',
  NOK = 'Não consta',
  OK_WITH_PROBLEMS = 'Consta com ressalvas',
}

export interface JourneyOverviewFilter {
  section_id?: string;
  start_date: string;
  end_date: string;
  sort_key?: string;
  sort_value?: string;
}

export interface JourneyControlState {
  journeyControl: {
    journeyOverview: {
      data: JourneyOverview[];
      currentPage: number;
      totalItems: number;
      totalPages: number;
      limitPerPage: number;
      offset: number;
      filters: JourneyOverviewFilter;
      setLimitPerPage: (limitPerPage: number) => void;
      setCurrentPage: (page: number) => void;
      setFilters: (filters: JourneyOverviewFilter) => void;
    };
    selectedDateType: string;
    isLoadingJourneyOverview: boolean;
    isLoadingAdhesionChartData: boolean;
    getJourneyOverview: () => void;
    getAdhesionChartData: (userId?: string) => void;
  }
}